import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AdminLoadingScreen from './AdminLoadingScreen';

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <AdminLoadingScreen variant="page" message="Verificando sesión..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/leoradmin/login" replace state={{ from: location }} />;
  }

  return children;
}
